import { useCallback, useEffect, useMemo, useState } from 'react';

import { useFetchAllNaps } from '../actions/erp';
import { CustomMapComponent } from '../components/ui';
import { Naps } from '../interfaces';
import { CoordenadasType } from '../components/ui/Maps/CustomMapComponent';

export type UseMapComponentProps = {
  initialCenter?: CoordenadasType
  napsByCity?: Naps[];
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  currentCity: string;
  currentSector?: number;
  longitudFormKey?: string;
  latitudFormKey?: string;
  form?: any;

  distanciaNapKey?: string;
  canUpdateLatLong?: boolean;

  coordenadasCliente: string;

  setCurrentCoordenadas?: (value: string) => void;

  enabledFetchNaps?: boolean;

  selectedNode?: string | null;

  onChangeMarker?: (value: CoordenadasType) => void;
};

export const useMapComponent = ({
  currentCity,
  currentSector,
  latitudFormKey = 'latitud',
  longitudFormKey = 'longitud',
  form,
  // distanciaNapKey = 'distancia',
  canUpdateLatLong = true,
  coordenadasCliente,
  enabledFetchNaps = true,

  selectedNode = null,

  onChangeMarker,
}: UseMapComponentProps) => {

  const [currentCoordenadas, setCurrentCoordenadas] = useState<string>(
    coordenadasCliente || '0,0'
  );

  const coordenadasClienteSplit = currentCoordenadas.split(',');
  const latInit = coordenadasClienteSplit?.[0] || -0.30519;
  const lngInit = coordenadasClienteSplit?.[1] || -78.45622;

  const [latLng, setLatLng] = useState<CoordenadasType>({
    lat: +latInit,
    lng: +lngInit
  });
  const [selectedNap, setSelectedNap] = useState<Naps | null>(null);
  const [filterCity, setfilterCity] = useState<string>(currentCity);
  const [filterSector, setFilterSector] = useState(currentSector);
  const Map = useMemo(() =>
    CustomMapComponent,
    [latLng.lat, latLng.lng]);

  ///* fetch naps by city
  const {
    data: napsByCity,
    isLoading: isLoadingNapsByCity,
    isRefetching: isRefetchingNapsByCity,
  } = useFetchAllNaps({
    enabled: enabledFetchNaps,
    params: {
      page_size: 1000,
      ciudad: filterCity,
      lat: currentCoordenadas.split(',')[0],
      lng: currentCoordenadas.split(',')[1],

      ...(selectedNode && { nodo_codigo: selectedNode! }),
    },
  });

  const setLatLngCb = useCallback(
    (value: CoordenadasType) => {
      setLatLng(value);
      form.setValue(latitudFormKey, value.lat.toString());
      form.setValue(longitudFormKey, value.lng.toString());
    },
    [setLatLng]
  );

  ///* effects
  // upd coordenadas when the marker is moved
  useEffect(() => {
    if (!canUpdateLatLong) return;
    onChangeMarker && onChangeMarker(latLng);
    form.reset({
      ...form.getValues(),
      coordenadas: `${latLng.lat},${latLng.lng}`,
    });

    // re-fetch naps
    setCurrentCoordenadas(`${latLng.lat},${latLng.lng}`);
  }, [latLng, canUpdateLatLong]);


  return {
    Map,
    latLng,
    setLatLng: setLatLngCb,
    napsByCity: napsByCity?.data?.data || [],
    isRefetchingNapsByCity,
    isLoadingNapsByCity,
    selectedNap,
    setSelectedNap,
    setfilterCity,

    setFilterSector,
    filterSector,

    currentCoordenadas,
    setCurrentCoordenadas,
  };
};
